export default __webpack_public_path__ + "static/media/m5.d241ffa5.jpg";